var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0569 7.89398C13.2592 7.89398 12.2621 8.09337 11.4645 8.49223C11.8633 8.8911 12.0627 9.28987 12.0627 9.88812C12.0627 11.0846 11.0656 11.8823 10.0686 11.8823C9.47035 11.8823 9.07148 11.6829 8.67271 11.284C8.27385 12.0816 8.07446 13.0787 8.07446 13.8764C8.07446 17.2665 10.8663 19.8589 14.057 19.8589C17.4471 19.8589 20.0395 17.067 20.0395 13.8764C20.0394 10.6858 17.4469 7.89398 14.0569 7.89398Z",
    fill: "#CECABE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7845 33.0205L29.8107 23.8473L28.4148 25.2432L25.4236 22.252C27.019 19.859 28.016 17.0671 28.016 13.8765C28.016 7.09633 22.6317 1.11384 15.8516 0.116722C6.47899 -1.07978 -1.49764 7.09633 0.297109 16.6683C1.29422 22.252 5.88074 26.6392 11.4645 27.6362C15.6522 28.4338 19.4411 27.2373 22.4323 25.0438L25.4236 28.0351L24.0277 29.6304L33.0015 38.8036C34.5968 40.3989 37.1892 40.3989 38.5851 38.8036C40.3798 37.0087 40.3798 34.6157 38.7845 33.0205ZM14.0569 23.8472C8.47322 23.8472 4.08599 19.4601 4.08599 13.8764C4.08599 8.29264 8.47313 3.90561 14.0569 3.90561C19.6406 3.90561 24.0277 8.29274 24.0277 13.8765C24.0277 19.4602 19.6405 23.8472 14.0569 23.8472Z",
    fill: "#CECABE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2);
export default __webpack_public_path__ + "static/media/a2.ccec80624a989a7aae01eafce761eaba.svg";
export { ForwardRef as ReactComponent };